import React from "react";
import { withRouter, Link } from "react-router-dom";
import { CurrentUserResource } from "../../stores/CurrentUserStore/Types";

interface Props {
  isOpen: boolean;
  currentUser: CurrentUserResource;
  closePanel: () => void;
}

const MobileNav: React.FC<Props> = ({ isOpen, closePanel, currentUser }) => {
  return (
    <>
      <div
        className={`mobile-nav-backdrop ${isOpen ? "is-open" : ""}`}
        id="mobileNavBackdrop"
        aria-hidden={!isOpen}
        onClick={closePanel}
      ></div>
      <div
        className={`mobile-panel mobile-nav ${isOpen ? "is-open" : ""}`}
        id="mobilePanel"
        aria-hidden={!isOpen}
      >
        <ul>
          <li>
            {location.pathname === "/profile" && (
              <Link
                to={currentUser.kind === "current-user" ? "/profile" : "/"}
                onClick={closePanel}
                className={`ui item  ${
                  location.pathname === "/profile" ? "active" : ""
                }`}
              >
                Home
              </Link>
            )}
          </li>
          <li>
            <Link
              to="/courses"
              onClick={closePanel}
              className={`ui item  ${
                location.pathname === "/courses" ? "active" : ""
              }`}
            >
              Courses
            </Link>
          </li>
          <li>
            <Link
              to="/team_plans"
              onClick={closePanel}
              className={`ui item  ${
                location.pathname === "/team_plans" ? "active" : ""
              }`}
            >
              For Teams
            </Link>
          </li>
          <li>
            <Link
              to="/workshops"
              onClick={closePanel}
              className={`ui item  ${
                location.pathname === "/workshops" ? "active" : ""
              }`}
            >
              Workshops
            </Link>
          </li>
          <li>
            <Link
              to="/community"
              onClick={closePanel}
              className={`ui item  ${
                location.pathname === "/community" ? "active" : ""
              }`}
            >
              Community
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              onClick={closePanel}
              className={`ui item  ${
                location.pathname === "/about" ? "active" : ""
              }`}
            >
              About
            </Link>
          </li>
          <li>
            <Link to="/blog" onClick={closePanel}>
              Blog
            </Link>
          </li>

          <li>
            <Link to="/login" onClick={closePanel}>
              Log in
            </Link>
          </li>
        </ul>

        <div className="mobile-panel-foot">
          <a
            href="#"
            data-smooth-scroll-to="#sample-courses-container"
            className="btn btn-blue"
            onClick={closePanel}
          >
            Try a course on us &rarr;
          </a>
        </div>
      </div>
    </>
  );
};

export default withRouter(MobileNav);
